<template lang="pug">
    div.icon-button-control(@click="click")
        svg-icon(:iconId="iconId")
</template>

<script>
export default {
    name: 'icon-button-control',
    props: {
        iconId: {
            type: String,
            required: true,
        },
    },
    methods: {
        click() {
            this.$emit('click')
        },
    },
}
</script>
